import { apiEndpoint, requestPayload } from '../utils/common';
import { API } from '../constant';
import { post } from '../utils/http';

/**
 *  Net banking channels available based on merchant or add money
 *
 * @param {Boolean} isAddMoney - if true than add money nb channels shown otherwise merchant nb channels
 * @returns {Promise<Object>} - Promise object
 */
export function nbChannels(isAddMoney) {
  return post.call(
    this,
    apiEndpoint(API.NB_CHANNELS),
    requestPayload({ type: isAddMoney ? 'ADD_MONEY' : 'MERCHANT' })
  );
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/nb.js